import { CSSProperties, forwardRef, PropsWithChildren } from 'react';
import styles from './panel.module.css';
import { cn } from '../../utils';
import { Pictogram, Pictograms } from '../symbols';
import { Slot, Slottable } from '@radix-ui/react-slot';

export enum PanelVariant {
  Default = 'default',
  Info = 'info',
  Timeline = 'timeline',
}

type PanelProps = PropsWithChildren<
  React.HTMLAttributes<HTMLDivElement> & {
    variant?: PanelVariant;
    // @deprecated Use `asChild` instead
    as?: React.ElementType;
    asChild?: boolean;
    style?: CSSProperties;
    pictogram?: Pictograms;
    title?: React.ReactNode;
    testId?: string;
  }
>;
/**
 * Panel component is used to group and organize content.
 * @param as - Deprecated, use `asChild` instead
 */
export const Panel = forwardRef<HTMLDivElement, PanelProps>(
  (
    {
      as,
      asChild,
      children,
      className,
      title,
      pictogram,
      variant = PanelVariant.Default,
      testId,
      ...props
    },
    ref,
  ) => {
    if (as) {
      console.log('Panel `as` prop is deprecated, use `asChild` instead');
    }

    const Comp = asChild ? Slot : as || 'div';

    return (
      <Comp
        ref={ref}
        data-testid={testId}
        className={cn(styles.container, variant && styles[variant], className)}
        {...props}
      >
        {title && (
          <div className={styles['header']}>
            {pictogram && (
              <Pictogram
                name={pictogram}
                size="2rem"
                className={styles['pictogram']}
              />
            )}
            <h3>{title}</h3>
          </div>
        )}
        <Slottable>{children}</Slottable>
      </Comp>
    );
  },
);
